import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ClienteSituacaoCadastrosFilterPipe } from '../../../../home/pessoa/cliente/situacao/pipes';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-cliente-situacao-multi-select',
  templateUrl: './novo-cliente-situacao-multi-select.component.html',
  providers: [
    ClienteSituacaoCadastrosFilterPipe,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoClienteSituacaoMultiSelectComponent),
      multi: true
    }
  ]
})
export class NovoClienteSituacaoMultiSelectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit, OnChanges {
  @Input() situacoes: number[] = [];
  @Input() cadastros: number[] = [];
  @Input() situacoesExcludes: number[] = [];
  @Input() variante: 'filtro' | undefined;
  @Input() icon = 'fa-heartbeat';

  @Output() changed = new EventEmitter<number[]>();

  options: IOption[] = [];
  @Input() settings: IMultiSelectSettings = {
    placeholder: 'Situações',
    singular: 'Situações',
    plural: 'Situações',
    searchEmptyResultMessage: 'Nenhuma situação encontrada',
    showFooter: true
  };

  settingsDoSelect: IMultiSelectSettings = {};

  constructor(
    private clienteSituacaoCadastrosFilterPipe: ClienteSituacaoCadastrosFilterPipe
  ) {
    super();
  }

  ngOnInit() {
    this.settingsDoSelect = { ...this.settings, hasSearchField: false };
    this.create();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.settingsDoSelect = { ...this.settings, hasSearchField: false };

    if (
      (changes['cadastros'] && !changes['cadastros'].isFirstChange()) ||
      (changes['situacoesExcludes'] &&
        !changes['situacoesExcludes'].isFirstChange())
    ) {
      this.create();
    }
  }

  private create() {
    this.options = this.clienteSituacaoCadastrosFilterPipe
      .transform(this.cadastros, this.situacoesExcludes)
      .map((situacao) => ({
        id: situacao.id,
        label: situacao.nome,
        isChecked: false
      }));
  }

  protected updateValue(newValue: number[] | null): void {
    this.situacoes = newValue || [];
  }

  onSelectionChange(): void {
    this.emitChange(this.situacoes);
  }

  onSearch(): void {
    this.changed.emit(this.situacoes);
  }
}
